import queryString from 'query-string'

interface MidwayAuthParams {
    scope: string
    response_type: string
    client_id: string
    redirect_uri: string
    nonce: string
}

const MIDWAY_URL = 'https://midway-auth.amazon.com/SSO'

const AUTH_SCOPE = 'openid'
const AUTH_RESPONSE_TYPE = 'id_token'

/**
 * Utility Function to Generate Random Nounce
 */
const generateRandomNounce: () => string = () => {
    return Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
}

/**
 * A Utility Function to build Request URL for retrieving
 * an ID Token (when isRedirectReq is FALSE) or for building
 * a URL to redirect to (when isRedirectReq is TRUE)
 *
 * @param isRedirectReq - boolean specifying if user is authenticated or not
 */
const buildMidwayAuthReq = (isRedirectReq = false) => {
    const paramsObj: MidwayAuthParams = {
        scope: AUTH_SCOPE,
        response_type: AUTH_RESPONSE_TYPE,
        client_id: window.location.origin,
        redirect_uri: document.location.href,
        nonce: generateRandomNounce(),
    }

    const params = queryString.stringify(paramsObj)
    const midwayUrl = isRedirectReq ? `${MIDWAY_URL}/redirect?${params}` : `${MIDWAY_URL}?${params}`
    return midwayUrl;
}

/**
 * Builds a midway auth request with Redirect set to true
 */
const buildMidwayAuthRedirectReq = () => {
    return buildMidwayAuthReq(true)
}

/**
 * Sets the page to midway Auth URL built for redirecting
 */
const beginNewLogin = () => {
    window.location.assign(buildMidwayAuthRedirectReq())
}

/**
 * Calls the endpoint to fetch an ID Token for the authenticated user
 */
const fetchIdentityToken = () => {
    return fetch(buildMidwayAuthReq(), { credentials: 'include' }).then((response) => {
        if (response.ok) {
            return response.text()
        }
        throw Error(response.statusText)
    })
}

const getIdentityToken = async () => {
    let idToken
    try {
        idToken = await fetchIdentityToken()
    } catch (err) {
        beginNewLogin()
    }
    return idToken
}

export {
    MIDWAY_URL,
    generateRandomNounce,
    buildMidwayAuthReq,
    buildMidwayAuthRedirectReq,
    getIdentityToken,
}
